import { jsx as _jsx } from "react/jsx-runtime";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { Suspense } from "react";
import styled from "styled-components";
import { LazySearchProductsRelatedSearchSection } from "@faire/retailer/components/SearchProducts/SearchProductsRelatedSearchSection";
import { discoverSearch } from "@faire/retailer/lib/seoPaths";
export var RelatedSearchList = function(param) {
    var productRelatedSearches = param.productRelatedSearches;
    return /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
        forceRender: isPrerender(),
        children: (productRelatedSearches === null || productRelatedSearches === void 0 ? void 0 : productRelatedSearches.length) ? /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(StyledLazySearchProductsRelatedSearchSection, {
                relatedSearchTerms: productRelatedSearches !== null && productRelatedSearches !== void 0 ? productRelatedSearches : [],
                onSearchTermClick: function(searchTerm) {
                    trackEvent("/click/product-page-carousel/related-searches/".concat(searchTerm));
                },
                generateSearchTermUrl: discoverSearch,
                leftAlign: true
            })
        }) : null
    });
};
var StyledLazySearchProductsRelatedSearchSection = styled(LazySearchProductsRelatedSearchSection).withConfig({
    componentId: "sc-3d90a662-0"
})([
    "padding:",
    ";",
    "{padding:",
    ";}"
], getSpacing("3x", "2x"), responsiveMediaQueries.tabletAndAbove, getSpacing("5x", "6x"));
